import Lookup from 'src/componentes/select-async';
import AcaoList from 'src/paginas/acao/view';

const AcaoLookup = (props) => {
  return (
    <Lookup
      useClickToOpen={false}
      showSearch
      labelKey="descricao"
      valueKey="id"
      url="/AcaoLookup"
      clearable={true}
      searchComponent={AcaoList}
      {...props}
    />
  );
};

export default AcaoLookup;
